export type GymHealthDeclarationGender = 'male' | 'female' | 'other';

/** Yes/no medical questions (Q3–Q16). */
export type GymHealthDeclarationAnswers = {
  heart_disease: boolean;
  chest_pain_at_rest: boolean;
  chest_pain_daily_activity: boolean;
  chest_pain_exercise: boolean;
  dizziness_balance_loss: boolean;
  loss_of_consciousness: boolean;
  asthma_recent_symptoms: boolean;
  family_heart_disease_death: boolean;
  family_sudden_early_death: boolean;
  doctor_supervised_activity_only: boolean;
  other_chronic_limiting_condition: boolean;
  high_risk_pregnancy: boolean;
  smoker: boolean;
};

export type GymHealthDeclarationWirePayload = {
  gender: GymHealthDeclarationGender;
  birth_date: string;
  answers: GymHealthDeclarationAnswers;
  declaration_agreed: boolean;
};

export type GymHealthDeclarationRecord = GymHealthDeclarationWirePayload & {
  submitted_at: string;
  expires_at?: string;
};

export type GymHealthDeclarationFormState = {
  gender: GymHealthDeclarationGender | '';
  birthYear: string;
  birthMonth: string;
  birthDay: string;
  heart_disease: boolean | null;
  chest_pain_at_rest: boolean | null;
  chest_pain_daily_activity: boolean | null;
  chest_pain_exercise: boolean | null;
  dizziness_balance_loss: boolean | null;
  loss_of_consciousness: boolean | null;
  asthma_recent_symptoms: boolean | null;
  family_heart_disease_death: boolean | null;
  family_sudden_early_death: boolean | null;
  doctor_supervised_activity_only: boolean | null;
  other_chronic_limiting_condition: boolean | null;
  high_risk_pregnancy: boolean | null;
  smoker: boolean | null;
  declaration_agreed: boolean;
};

export const GYM_HEALTH_DECLARATION_BOOL_KEYS = [
  'heart_disease',
  'chest_pain_at_rest',
  'chest_pain_daily_activity',
  'chest_pain_exercise',
  'dizziness_balance_loss',
  'loss_of_consciousness',
  'asthma_recent_symptoms',
  'family_heart_disease_death',
  'family_sudden_early_death',
  'doctor_supervised_activity_only',
  'other_chronic_limiting_condition',
  'high_risk_pregnancy',
  'smoker',
] as const satisfies ReadonlyArray<keyof GymHealthDeclarationFormState>;

export function emptyGymHealthDeclarationForm(): GymHealthDeclarationFormState {
  return {
    gender: '',
    birthYear: '',
    birthMonth: '',
    birthDay: '',
    heart_disease: null,
    chest_pain_at_rest: null,
    chest_pain_daily_activity: null,
    chest_pain_exercise: null,
    dizziness_balance_loss: null,
    loss_of_consciousness: null,
    asthma_recent_symptoms: null,
    family_heart_disease_death: null,
    family_sudden_early_death: null,
    doctor_supervised_activity_only: null,
    other_chronic_limiting_condition: null,
    high_risk_pregnancy: null,
    smoker: null,
    declaration_agreed: false,
  };
}
